import 'phaser'
import { IJobCreator } from '../behavior/jobCreators'
import { jobCreators } from '../behavior/jobCreators-sidecar'
import { IJob } from '../behavior/jobs'
import { monstersAi } from './monstersAi-sidecar'
import { monstersJobCreators } from './monstersJobCreators-sidecar'
import { l } from '../lib/imports'
import { createId } from '../main/common'
import { common } from '../main/common-sidecar'
import { layers } from '../main/layers-sidecar'
import { scene } from '../main/scene-sidecar'
import { ITileMapShip } from '../tiles/tileMapShip'
import { PathType } from '../ui/pathHighligher'
import { spriteMap } from '../main/spriteMap-sidecar'
import { IFrameAnim, IFrameAnimData } from '../engine/anims'
import { anims } from '../engine/anims-sidecar'
import { ICargo } from '../entities/cargoes'
import { cargoes } from '../entities/cargoes-sidecar'
import { IEntity } from '../entities/entitiesUtils'
import { entitiesUtils } from '../entities/entitiesUtils-sidecar'
import { IHealthBar } from '../indicators/healthBars'
import { healthBars } from '../indicators/healthBars-sidecar'
import { monsterAnims } from './monstersAnims'
import { monstersAnims } from './monstersAnims-sidecar'
import { IMonsterData, MonsterType } from './monstersData'
import { monstersData } from './monstersData-sidecar'
import { monstersStats } from './monstersStats-sidecar'
import { particles } from '../entities/particles-sidecar'
import { stacks } from '../entities/stacks-sidecar'
import { monsterMovement } from './monsterMovement-sidecar'

export interface IMonster extends IEntity {
  type: MonsterType
  data: IMonsterData
  image: Phaser.GameObjects.Image
  idx: number
  i: number
  j: number
  path: PathType
  moveDelay: number

  anim: IFrameAnim
  team: number
  isFindingPath: boolean

  maxHitPoints: number
  hitPoints: number
  damage: number
  healthBar: IHealthBar
  isDying: boolean
  dyingDelay: number
  isAttacking: boolean
  attackDelay: number
  isAttackRecovering: boolean
  attackRecoverDelay: number

  // build a ship!
  jobCreators: IJobCreator[]
  currentJob: IJob | null
  carryingCargo: ICargo | null
  isInsideShip: boolean
  isInSuit: boolean
  isSleeping: boolean
  isInCombat: boolean
  currentMoveSpeed: number

  // stats
  statHunger: number
  statThirst: number
  statToilet: number
  statSocial: number
  statEntertainment: number
  statEnergy: number
  statName: string
  statOxygen: number
  statSuitOxygen: number

  idleTimer: number
}

const objs: IMonster[] = []
export function getAll() {
  return objs
}

export function playAnim(obj: IMonster, ad: IFrameAnimData, force?: boolean) {
  anims.play(obj.anim, ad, force)
  updateAnimFrame(obj)
}
export function updateAnim(obj: IMonster) {
  anims.update(obj.anim, () => {
    updateAnimFrame(obj)
  })
}
function updateAnimFrame(obj: IMonster) {
  spriteMap.setFrame(obj.image, obj.anim.data.frames[obj.anim.frameIdx].fi)
}

export function findById(id: number) {
  return entitiesUtils.findById(id, objs)
}

export function findAtSpot(i: number, j: number): IMonster | null {
  let closest: IMonster | null = null
  l.forEach(objs, (c) => {
    if (c.i === i && c.j === j) {
      //if (filter(c)) {
      closest = c
      return false
      // }
    }
  })
  return closest
}

export function create(type: MonsterType, team: number): IMonster {
  // x: number,
  // y: number,
  // idx: number,
  // team: number,
  let id = createId()
  let data = monstersData.getByType(type)

  let defaultFrame = monstersAnims.monsterAnims[0].dead.frames[0].fi
  let image = spriteMap.createImageFromFrameInfo(
    layers.getLayers().monsters,
    defaultFrame,
    0,
    0,
  )

  let anim = anims.create(monsterAnims[data.idx].s)

  let healthBar = healthBars.create()

  let obj: IMonster = {
    type,
    data,
    eType: 'monster',
    id,
    idx: data.idx,
    team,
    image,
    isDead: false,
    isDying: false,
    dyingDelay: 0,
    i: -1,
    j: -1,
    path: [],
    moveDelay: 0,
    anim,
    isFindingPath: false,
    maxHitPoints: data.maxHp,
    hitPoints: data.maxHp,
    damage: data.attackDamage,
    healthBar,
    attackDelay: 0,
    isAttacking: false,
    attackRecoverDelay: 0,
    isAttackRecovering: false,

    jobCreators: [],

    currentJob: null,
    carryingCargo: null,
    isInsideShip: true,
    isInSuit: false,
    isInCombat: false,
    isSleeping: false,
    currentMoveSpeed: 0.5,

    statEntertainment: 100,
    statHunger: 100,
    statName: 'Stevie',
    statSocial: 100,
    statThirst: 100,
    statToilet: 100,
    statEnergy: 100,
    statOxygen: 100,
    statSuitOxygen: 0,
    idleTimer: 0,
  }
  playAnim(obj, anim.data, true)
  obj.jobCreators = monstersJobCreators.create(obj)
  objs.push(obj)

  return obj
}

export function setPath(obj: IMonster, path: PathType | null) {
  if (!path) {
    path = []
  }
  if (path) {
    obj.path = path

    obj.moveDelay = monsterMovement.calcMoveSpeed(obj)
    let first = path[0]
    if (first) {
      if (first.x === obj.i && first.y === obj.j) {
        obj.path.shift()
      }
    }
  }
}

export function moveToTile(
  obj: IMonster,
  map: ITileMapShip,
  x: number,
  y: number,
) {
  obj.image.x = map.ox + x * map.tileSize
  obj.image.y = map.oy + y * map.tileSize
  obj.i = x
  obj.j = y
}

export function lerpToTile(
  obj: IMonster,
  map: ITileMapShip,
  i: number,
  j: number,
  lerp: number,
) {
  if (lerp < 0) {
    // console.log('lerp < 0!', lerp)
    lerp = 0
  }
  if (lerp > 1) {
    // console.log('lerp > 1!', lerp)
    lerp = 1
  }
  obj.image.x =
    map.ox + ((1 - lerp) * obj.i * map.tileSize + lerp * i * map.tileSize)
  obj.image.y =
    map.oy + ((1 - lerp) * obj.j * map.tileSize + lerp * j * map.tileSize)
}

export function damage(obj: IMonster, damage: number) {
  if (obj.isDying || obj.isDead) {
    return
  }
  particles.create('blood', obj.image.x, obj.image.y)
  obj.hitPoints -= damage
  if (obj.hitPoints <= 0) {
    kill(obj)
  }
}

export function killAll() {
  objs.forEach((c) => {
    kill(c, true)
  })
}

export function kill(obj: IMonster, immedate: boolean = false) {
  if (immedate) {
    obj.isDead = true
    obj.image.tint = 0xccc
    healthBars.kill(obj.healthBar)
  }
  if (obj.isDead || obj.isDying) {
    return
  }

  if (!obj.isDying) {
    obj.isDying = true
    obj.dyingDelay = obj.data.deathSpeed
    playAnim(obj, monstersAnims.monsterAnims[obj.idx].dead)
    if (!obj.data.canRespawn) {
      healthBars.kill(obj.healthBar)
    }
  }
}

export function updateAll() {
  objs.forEach((c) => {
    monstersAi.update(c)
    update(c)
  })
  entitiesUtils.removeDead(objs, (c) => {
    c.image.destroy()
    c.currentJob = jobCreators.destroyAll(c.jobCreators, c.currentJob)
  })
}
function update(obj: IMonster) {
  if (obj.isDying) {
    obj.dyingDelay -= common.getUpdateDeltaScaled()
    if (obj.dyingDelay < 0) {
      if (obj.data.canRespawn) {
        obj.isDying = false
        obj.hitPoints = obj.maxHitPoints / 2
        playAnim(obj, monstersAnims.monsterAnims[obj.idx].s)
        obj.isAttackRecovering = false
        obj.isAttacking = false
      } else {
        kill(obj, true)
      }
    }
    return
  }
  if (obj.isDead) {
    return
  }

  monstersStats.run(obj)

  updateAnim(obj)

  obj.image.visible = !obj.isSleeping

  if (obj.carryingCargo) {
    obj.carryingCargo.image.x = obj.image.x
    obj.carryingCargo.image.y = obj.image.y - 20
  }
}

export function setInSuit(obj: IMonster, inSuit: boolean) {
  if (inSuit !== obj.isInSuit) {
    obj.currentMoveSpeed = 0.75
    if (!inSuit) {
      // obj.currentMoveSpeed = 0.5
    } else {
      obj.statSuitOxygen = 100
    }
  }
  obj.isInSuit = inSuit
  updateIdx(obj)
}

export function setIsSleeping(obj: IMonster, isSleeping: boolean) {
  obj.isSleeping = isSleeping
  // playIdleAnimTowards(obj, obj.i, obj.j + 1)
}

export function playAttackAnimTowards(obj: IMonster, x: number, y: number) {
  if (x > obj.i) {
    playAnim(obj, monsterAnims[obj.idx].eAttack)
  }
  if (x < obj.i) {
    playAnim(obj, monsterAnims[obj.idx].wAttack)
  }
  if (y > obj.j) {
    playAnim(obj, monsterAnims[obj.idx].sAttack)
  }
  if (y < obj.j) {
    playAnim(obj, monsterAnims[obj.idx].nAttack)
  }
}

export function playIdleAnimTowards(
  obj: IMonster,
  x: number,
  y: number,
  force: boolean = false,
) {
  if (x > obj.i) {
    playAnim(obj, monsterAnims[obj.idx].e, force)
  }
  if (x < obj.i) {
    playAnim(obj, monsterAnims[obj.idx].w, force)
  }
  if (y > obj.j) {
    playAnim(obj, monsterAnims[obj.idx].s, force)
  }
  if (y < obj.j) {
    playAnim(obj, monsterAnims[obj.idx].n, force)
  }
}
export function getAtMouse(
  mx: number,
  my: number,
  teamNumber: number,
): IMonster | null {
  let found: IMonster | null = null

  let r = 40

  l.forEach(objs, (c) => {
    if (c.team === teamNumber) {
      if (c.image.x - r < mx && c.image.x + r / 2 > mx) {
        if (c.image.y - r / 2 < my && c.image.y + r / 2 > my) {
          found = c
          return false
        }
      }
    }
  })
  return found
}

export function pickupCargo(obj: IMonster, cargo: ICargo) {
  if (obj.carryingCargo) {
    dropCargo(obj)
  }

  if (cargo.carriedBy) {
    throw new Error('already being carried cargo')
  }

  if (cargo.inStack) {
    stacks.removeFromStack(cargo.inStack, cargo)
  }

  cargo.carriedBy = obj
  obj.carryingCargo = cargo
}

export function dropCargo(obj: IMonster) {
  if (obj.carryingCargo) {
    let ctx = scene.getContext()
    cargoes.moveToTile(obj.carryingCargo, ctx.mapShip, obj.i, obj.j)
    obj.carryingCargo.isInShip = obj.isInsideShip
    obj.carryingCargo.carriedBy = null
    obj.carryingCargo = null
  }
}

export function consumeCargo(obj: IMonster) {
  if (obj.carryingCargo) {
    cargoes.kill(obj.carryingCargo)
    dropCargo(obj)
  }
}

export function setInsideOutside(obj: IMonster, isInside: boolean) {
  obj.isInsideShip = isInside
}

export function setInCombat(obj: IMonster, isInCombat: boolean) {
  //if (isInCombat !== obj.isInCombat) {
  obj.isInCombat = isInCombat
  updateIdx(obj)
  //}
}

function updateIdx(obj: IMonster) {
  //obj.idx = obj.data.idx
  //obj.idx = 33
  let idx = obj.data.idx
  if (obj.type === 'human') {
    if (obj.isInSuit) {
      idx = 33
    }
    if (obj.isInCombat) {
      idx += 2
    }
  }
  if (idx !== obj.idx) {
    obj.idx = idx
    playIdleAnimTowards(obj, obj.i, obj.j + 1, true)
  }
}
